module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/left-adf33978d0ddc2d7b9e5c0e4d402ab2a.svg";